export default __webpack_public_path__ + "static/media/bird.cb41c2b2.jpg";